import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import { useNavigateChart } from "@/hooks/useNavigateChart";
import axiosInstance from "@/lib/axios";
import type { Encounter } from "@curai/js-fhir-tools";
import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "@tanstack/react-router";

export interface StartForcedLiveChatResponse {
  motherEncounter: Encounter;
}

export const useStartForcedLiveChat = () => {
  const { patientId } = useParams({ from: "/patient/$patientId" });
  const queryClient = useQueryClient();
  const navigateChart = useNavigateChart();

  return useApiMutation<StartForcedLiveChatResponse, void>({
    mutationOptions: {
      mutationKey: QueryKeys.Distribution.START_FORCED_LIVE_CHAT(patientId),
      mutationFn: async () => {
        const response = await axiosInstance.post(
          "/new-api/encounter/force-live-chat",
          {
            patientId,
            encounterStartType: "TEXT_BASED",
          },
        );
        return response.data;
      },
      onSuccess: (data) => {
        queryClient.refetchQueries({
          queryKey: QueryKeys.Provider.PATIENT_TABS,
        });

        navigateChart({ patientId, encounterId: data.motherEncounter.id });
      },
    },
  });
};
